module.exports = __webpack_public_path__ + "img/neobet_2026.77015376.png";